export default __webpack_public_path__ + "static/media/undraw_calendar_re_ki49.13f875f4.svg";